module.exports = __webpack_public_path__ + "img/podbean-w-fi-symbol.274ead68.png";